import React from 'react';
import { Modal, Row, Col, Input, message, Form, Select } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SearchRetrieve from '../../common/SearchRetrieve.new';

const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;

class UpdateRequireForm extends React.Component {
    state = {
        visible: false,
        confirmLoading: false,
        investigationSiteId: '',
        investigationSiteCode: '',
        user: {},
        selectedTab: "searchAdd",
        stageList: [],
        showDepartSelect: true,
        rateOfEntry: null,
        hospital: [],
        department: [],
        doctorlist: [],
        reDepart: true,
        reHos: true,
        CourtyardAreaList: [],
        needCourtyardArea: false, //院区必填判断
    }

    hide = () => {
        this.setState({
            reHos: false,
            reDepart: false,
        }, () => {
            this.setState({
                reHos: true,
                reDepart: true,
            })
        })
        this.props.changeinvVisible(false);
    }

    handleSubmit = () => {
        this.props.form.validateFields((err, values) => {
            if (err) {
                return;
            }
            const fieldValue = this.props.form.getFieldsValue() || {};
            const { hospitalMainId, hospitalDepartmentId, hospitalId, siteJoinRequireId, isAdd } = fieldValue;
            this.setState({
                confirmLoading: true,
            })
            const options = {
                url: isAdd ? `${API_URL.commentInfo.addSiteJoinRequire}` : `${API_URL.commentInfo.modifySiteJoinRequire}`,
                data: {
                    ...fieldValue,
                    hospitalMainId,
                    hospitalId,
                    hospitalDepartmentId,
                    siteJoinRequireId,
                },
                dataType: 'json',
                doneResult: (data => {
                    this.setState({
                        confirmLoading: false,
                    })
                    this.hide();
                    message.success(data.success);
                    this.props.loadData();
                }),
                errorResult: data => {
                    this.setState({
                        confirmLoading: false,
                    })
                }
            };
            $.sendRequest(options);

        });
    }

    handleSelectHospital = options => {
        this.props.form.setFieldsValue({
            hospitalMainId: options.value,
            hospitalName: options.text,
            hospitalId: undefined,
            courtyardArea: undefined,
            hospitalDepartmentId: undefined,
            departmentName: undefined,
        });
        options.value && this.queryCourtyardAreaList(options.value);
        this.setState({
            reDepart: true,
        })
    }

    queryCourtyardAreaList = (hospitalMainId) => {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('hospitalId');
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryHospitalCourtyardAreaList,
            data: {    
                hospitalMainId,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                let needCourtyardArea = false;
                (datas || []).map(el => {
                    if (el.courtyardArea) {
                        needCourtyardArea = true;
                    }
                });
                if (!needCourtyardArea) {
                    this.props.form.setFieldsValue({
                        hospitalId: datas[0].hospitalId,
                    });
                };
                this.setState({ CourtyardAreaList: datas, needCourtyardArea });
            }
        };
    $.sendRequest(options);
    }

    handleSelectqueryCourtyardArea = (value) => {
        this.props.form.setFieldsValue({
            hospitalId: value,
            courtyardArea: value,
            hospitalDepartmentId: undefined,
            departmentName: undefined,
        });
    }

    handleSelectHospitalDepartment = options => {
        this.props.form.setFieldsValue({
            hospitalDepartmentId: options.value,
            departmentName: options.text,
        });
    }

    render() {
        const { confirmLoading, reHos, reDepart, CourtyardAreaList, needCourtyardArea } = this.state;
        const { getFieldDecorator } = this.props.form;
        const CourtyardAreaOptions = CourtyardAreaList.map(i => <Option key={i.hospitalId}>{i.courtyardArea}</Option>)
        const formItemLayout = {
            labelCol: {
                span: 9
            },
            wrapperCol: {
                span: 13
            },
        };
        const fieldValue = this.props.form.getFieldsValue() || {};
        const { isAdd, departmentName, hospitalName, hospitalMainId, siteJoinRequireCode, hospitalId, courtyardArea } = fieldValue;
        return (
            <Modal
                title={isAdd ? "新建中心参与项目需求" : "修改中心参与项目需求"}
                visible={this.props.visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="450px"
                confirmLoading={confirmLoading}
            >
                <div>
                    <Form>
                        {
                            !isAdd &&
                            <Row>
                                <Col span={9} style={{ textAlign: "right", paddingRight: "15px" }}>需求编号：</Col>
                                <Col span={14} style={{ whiteSpace: "normal", wordBreak: "break-all" }}>
                                    {siteJoinRequireCode}
                                </Col>
                            </Row>
                        }

                        {isAdd ?
                            <div className="field-max">
                                <FormItem label="医院名称" className="search_label">
                                    {reHos ?
                                        <SearchRetrieve
                                            keyword='hospitalName'
                                            style={{ width: 225 }}
                                            params={{ limit: 10, offset: 1 }}
                                            placeholder="输入医院自动检索"
                                            value={hospitalName}
                                            url={API_URL.hospital.queryHospitalMainList}
                                            config={{ id: 'hospitalMainId', name: 'hospitalMainName' }}
                                            onChange={options => this.handleSelectHospital( options )}
                                        />
                                        :
                                        null
                                    }
                                    {
                                        getFieldDecorator('hospitalMainId', {
                                            rules: [
                                                { required: true, message: '医院名称不能为空' }
                                            ],
                                        })(
                                            <input style={{ display: 'none' }} />
                                        )
                                    }
                                </FormItem>
                            </div>
                            :
                            <Row>
                                <Col span={9} style={{ textAlign: "right", paddingRight: "15px" }}>医院名称：</Col>
                                <Col span={14} style={{ whiteSpace: "normal", wordBreak: "break-all" }}>
                                    {hospitalName}
                                </Col>
                            </Row>
                        }
                        <div className="field-max">
                                <FormItem label="院区" className="search_label">
                                    {
                                        <Select
                                            style={{ width: 225 }}
                                            placeholder="请输入"
                                            disabled={ !needCourtyardArea || !hospitalMainId } 
                                            value={courtyardArea}
                                            onChange={value => this.handleSelectqueryCourtyardArea(value, 'courtyardArea')}
                                        >
                                            {CourtyardAreaOptions}
                                        </Select>
                                    }
                                    {
                                        getFieldDecorator('courtyardArea', {
                                            initialValue: "请选择院区",
                                            rules: [
                                                { required: needCourtyardArea, message: '院区不能为空' }
                                            ],
                                        })(
                                            <input style={{ display: 'none' }} />
                                        )
                                    }
                                </FormItem>
                            </div>
                        {isAdd ?
                            <div className="field-max">
                                <FormItem label="科室" className="search_label">
                                    {
                                        reDepart ?
                                            <SearchRetrieve
                                                keyword="hospitalDepName"
                                                style={{ width: 225 }}
                                                placeholder="输入科室名称检索"
                                                disabled={ !needCourtyardArea ? !hospitalMainId : !courtyardArea} 
                                                value={ departmentName }
                                                params={{ limit: 20, hospitalId: hospitalId }}
                                                url={API_URL.hospital.queryDepWhenAddDoctor}
                                                config={{ id: 'hospitalDepartmentId', name: 'departmentLocalName' }}
                                                onChange={options => this.handleSelectHospitalDepartment( options )}
                                            />
                                            :
                                            null
                                    }

                                    {
                                        getFieldDecorator('hospitalDepartmentId', {
                                            initialValue: "请选择科室",
                                            rules: [
                                                { required: true, message: '科室不能为空' }
                                            ],
                                        })(
                                            <input style={{ display: 'none' }} />
                                        )
                                    }
                                </FormItem>
                            </div>
                            :
                            <Row>
                                <Col span={9} style={{ textAlign: "right", paddingRight: "15px" }}>科室：</Col>
                                <Col span={14} style={{ whiteSpace: "normal", wordBreak: "break-all" }}>
                                    {departmentName}
                                </Col>
                            </Row>
                        }
                        <div className="field-max">
                            <FormItem label="项目意向(适应症)" {...formItemLayout}>
                                {
                                    getFieldDecorator('investigationMalady', {
                                        rules: [
                                            { required: true, message: '项目意向不能为空' },
                                        ],
                                    })(<Input />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="备注" {...formItemLayout}>
                                {
                                    getFieldDecorator('comments', {
                                        rules: [
                                            { required: true, message: '备注不能为空' },
                                        ],
                                    })(<TextArea rows={4} />)
                                }
                            </FormItem>
                        </div>
                        <div style={{ display: "none" }}>
                            {
                                getFieldDecorator('siteJoinRequireId', {
                                })(<Input type="hidden" />)
                            }
                            {
                                getFieldDecorator('siteJoinRequireCode', {
                                })(<Input type="hidden" />)
                            }
                            {
                                getFieldDecorator('isAdd', {
                                })(<Input type="hidden" />)
                            }
                            {
                                getFieldDecorator('hospitalName', {
                                })(<Input type="hidden" />)
                            }
                            {
                                getFieldDecorator('departmentName', {
                                })(<Input type="hidden" />)
                            }
                        </div>
                    </Form>
                </div>
            </Modal>
        )
    }
}

const UpdateRequire = Form.create({
    mapPropsToFields(props) {
        const { info = {}, isAdd } = props;
        return {
            hospitalId: {
                value: info.hospitalId,
            },
            hospitalDepartmentId: {
                value: info.hospitalDepartmentId,
            },
            siteJoinRequireCode: {
                value: info.siteJoinRequireCode,
            },
            siteJoinRequireId: {
                value: info.siteJoinRequireId,
            },
            comments: {
                value: info.comments,
            },
            investigationMalady: {
                value: info.investigationMalady,
            },
            hospitalName: {
                value: info.hospitalName,
            },
            departmentName: {
                value: info.departmentName,
            },
            isAdd: {
                value: isAdd,
            }
        };
    },
})(UpdateRequireForm);

export default UpdateRequire;



// WEBPACK FOOTER //
// ./src/components/siteComment/researchCenterRecommend/UpdateRequirement.js